
import OpenChatReportApi from '@/api/OpenChatReportApi'
import { defineComponent, onBeforeUnmount, onMounted, reactive, ref } from 'vue'
import { Progress } from 'ant-design-vue'
 
export default defineComponent({
  components: {
    Progress
  },
  setup () {
    let timer = 0
    const total = ref(0)
    const userData = reactive([
      {
        label: '在线人数',
        value: 0
      },
      {
        label: '示忙人数',
        value: 0
      },
      {
        label: '离线人数',
        value: 0
      }
    ])

    function countEngineerStatusDistribution () {
      OpenChatReportApi.countEngineerStatusDistribution()
        .then((res:any) => {
          total.value = res.totalCount
          userData[0].value = res?.onlineCount
          userData[1].value = res?.showBusyCount
          userData[2].value = res?.offlineCount
          timer = setTimeout(() => {
            countEngineerStatusDistribution()
          }, 3000);
        })
    }
    
    onMounted(() => {
      countEngineerStatusDistribution()
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    return {
      total,
      userData
    }
  }
})
